import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useAddNisMasterlist = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const addNisMasterlist = async (formData) => {
    setLoading(true);
    setSuccess(false);
    setError('');

    try {
  const response = await axiosApi.post('/nisMasterlist/insert', formData);
      console.log('API Response:', response.data);

      // ✅ Adjust to match your backend response shape
      if (response.status === 200 && response.data?.success) {
        setSuccess(true);
        return { success: true };
      } else {
        const message = response.data?.message || 'Failed to add the data. Please try again.';
        setError(message);
        return { success: false, message };
      }
    } catch (err) {
      console.error('Error submitting data:', err);
      setError(err.response?.data?.message || 'Something went wrong. Please try again later.');
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    success,
    error,
    addNisMasterlist,
  };
};

export default useAddNisMasterlist;
